export default "__VITE_ASSET__DK_4iOPm__"